import { Nullable, ValueOf, Translations } from '../types/types'

export function getObjectKey<T>(obj: T): Nullable<string> {
  //@ts-ignore
  return Object.keys(obj).find((o: string) => o)
}

export function getObjectVal<T, K extends keyof T>(obj: T, key: K): ValueOf<T> {
  return obj[key]
}

// Used to flatten the translation nested messages before feeding the IntlProvider.
export const flatten = (nestedMessages: Translations, prefix = '') => {
  if (nestedMessages === null) {
    return {}
  }
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key]
    const prefixedKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === 'string') {
      Object.assign(messages, { [prefixedKey]: value })
    } else {
      Object.assign(messages, flatten(value, prefixedKey))
    }

    return messages
  }, {})
}
